import { render, staticRenderFns } from "./trainingmangesb.vue?vue&type=template&id=85d29b30&scoped=true"
import script from "./trainingmangesb.vue?vue&type=script&lang=js"
export * from "./trainingmangesb.vue?vue&type=script&lang=js"
import style0 from "./trainingmangesb.vue?vue&type=style&index=0&id=85d29b30&prod&lang=less"
import style1 from "./trainingmangesb.vue?vue&type=style&index=1&id=85d29b30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d29b30",
  null
  
)

export default component.exports